import React from 'react';
import { Navigate, RouteObject } from 'react-router-dom';

import { APP_ROUTES } from '@/shared/config/routes-config';
import { UserRole } from '@/shared/enums/user-role.enum';
import { RouteConfig } from '@/shared/interfaces/routes-config.interface';
import DefaultLayout from '@/shared/layouts/default/default.layout';

const CashoutListContainer = React.lazy(
  () => import('../../containers/cashout-list/cashout-list.container')
);

const CashoutCreateContainer = React.lazy(
  () => import('../../containers/cashout-create/cashout-create.container')
);

const CashoutDetailsContainer = React.lazy(
  () => import('../../containers/cashout-details/cashout-details.container')
);

export const CashoutRoutesConfig: RouteObject[] = [
  {
    index: true,
    element: <Navigate to={(APP_ROUTES.CASH_OUT_MODULE.CHILDREN as RouteConfig).LIST.FULL_PATH} />
  },
  {
    path: (APP_ROUTES.CASH_OUT_MODULE.CHILDREN as RouteConfig).LIST.FULL_PATH,
    element: (
      <React.Suspense fallback={<div>Loading...</div>}>
        <DefaultLayout
          authenticationRequired={true}
          permittedList={[UserRole.ADMIN, UserRole.FINANCE_OFFICER]}
          component={CashoutListContainer}
        />
      </React.Suspense>
    )
  },
  {
    path: (APP_ROUTES.CASH_OUT_MODULE.CHILDREN as RouteConfig).DETAILS.FULL_PATH,
    element: (
      <React.Suspense fallback={<div>Loading...</div>}>
        <DefaultLayout
          authenticationRequired={true}
          permittedList={[UserRole.ADMIN, UserRole.FINANCE_OFFICER]}
          component={CashoutDetailsContainer}
        />
      </React.Suspense>
    )
  },
  {
    path: (APP_ROUTES.CASH_OUT_MODULE.CHILDREN as RouteConfig).CREATE.FULL_PATH,
    element: (
      <React.Suspense fallback={<div>Loading...</div>}>
        <DefaultLayout
          authenticationRequired={true}
          permittedList={[UserRole.ADMIN]}
          component={CashoutCreateContainer}
          addLayout
        />
      </React.Suspense>
    )
  }
];
